import Swal from 'sweetalert2';

const SweetAlert = {

  toastSuccess: (title) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    Toast.fire({
      icon: "success",
      title: title,
    });
  },

  toastError: (title) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    Toast.fire({
      icon: "error",
      title: title,
    });
  },

  toastSuccessWithSubtitle: (title, subtitle) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    Toast.fire({
      icon: "success",
      title: title,
      html: subtitle ? `<small class="toast-subtitle">${subtitle}</small>` : '',
      customClass: {
        popup: 'subtitle-toast'
      }
    });
  },

  toastInfo: (title) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    Toast.fire({
      icon: "info",
      title: title,
    });
  },

  toastLoading: (title = "Carregando...") => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    Toast.fire({
      icon: "info",
      title: title,
    });
  },

  success: (title, text) => {
    return Swal.fire({
      icon: 'success',
      title: title || 'Sucesso!',
      text: text || 'A operação foi realizada com sucesso.',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
      confirmButtonColor: "#2b97be",
      timer: 10000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  },

  error: (title, text) => {
    return Swal.fire({
      icon: 'error',
      title: title || 'Erro',
      text: text || 'Ocorreu um erro ao realizar a operação.',
      confirmButtonText: 'Tentar Novamente',
      confirmButtonColor: "#d33",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
    });
  },

  errorHTML: (title, html) => {
    return Swal.fire({
      icon: 'error',
      title: title || 'Erro',
      html: html,
      confirmButtonText: 'Tentar Novamente',
      confirmButtonColor: "#d33",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
    });
  },

  warning: async (title, text) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: title || 'Aviso',
      text: text,
      confirmButtonColor: "#2b97be",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#d33",
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
    });

    if (result.isConfirmed) {
      return true;
    } else {
      return false;
    }
  },

  warningHTML: async (title, html) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: title || 'Aviso',
      html: html,
      confirmButtonColor: "#2b97be",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#d33",
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
    });

    if (result.isConfirmed) {
      return true;
    } else {
      return false;
    }
  },

  warningDevMode: async (title, text) => {
    return Swal.fire({
      icon: 'warning',
      title: title || 'Aviso',
      text: text,
      confirmButtonColor: "#2b97be",
      confirmButtonText: "OK",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
    });
  },

  loading: (title, text) => {
    const instance = Swal.fire({
      title: 'Carregando...' || title,
      text: 'Por favor, aguarde.' || text,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
      willClose: () => {
        Swal.hideLoading();
      },
    });
    return instance;
  },

  delete: async (confirmMessage) => {
    const result = await Swal.fire({
      title: "Deseja realmente excluir?",
      html: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2b97be",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
    });

    if (result.isConfirmed) {
      return true; // Retorna true para indicar que o item pode ser excluído
    } else {
      return false; // Retorna false se o usuário cancelar
    }
  },

  deselect: async (confirmMessage) => {
    const result = await Swal.fire({
      title: "Deseja realmente desativar a seleção?",
      html: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2b97be",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, desativar",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
    });

    if (result.isConfirmed) {
      return true; // Retorna true para indicar que o item pode ser excluído
    } else {
      return false; // Retorna false se o usuário cancelar
    }
  },

  close: async () => {
    return Swal.close();
  },
}

export default SweetAlert;
